import { Button } from '../ui/button';
import { Plus, FileText, Filter, FilterX, Truck, Settings } from 'lucide-react';

export const LoadsHeader = ({
  isApprover,
  draftsCount,
  activeTab,
  totalLoads,
  onToggleDrafts,
  onOpenFilter,
  onClearFilter,
  onOpenAdd,
  onOpenAdhocManager,
  hasActiveFilters
}) => {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
      <div>
        <p className="text-slate-500 text-sm font-bold tracking-[0.15em] uppercase mb-1">Logistics</p>
        <div className="flex items-center gap-2">
          <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-slate-900" style={{ fontFamily: "'Manrope', sans-serif" }}>Silica Loads</h1>
          {isApprover && (
            <div className="flex sm:hidden gap-1.5 ml-auto">
              <Button
                data-testid="filter-button"
                variant="outline"
                size="sm"
                onClick={onOpenFilter}
                className={`rounded-xl h-9 w-9 p-0 ${hasActiveFilters ? 'border-blue-500 text-blue-600 bg-blue-50' : ''}`}
                title="Filter"
              >
                <Filter className="w-4 h-4" />
              </Button>
              {hasActiveFilters && (
                <Button
                  data-testid="clear-filter-button"
                  variant="outline"
                  size="sm"
                  onClick={onClearFilter}
                  className="rounded-xl h-9 w-9 p-0 border-red-300 text-red-600 hover:bg-red-50"
                  title="Clear Filters"
                >
                  <FilterX className="w-4 h-4" />
                </Button>
              )}
              <Button 
                data-testid="add-load-btn-mobile" 
                size="sm" 
                onClick={onOpenAdd} 
                className="h-9 px-3 bg-gradient-to-r from-slate-800 to-slate-900 hover:from-slate-700 hover:to-slate-800 text-white rounded-xl shadow-lg shadow-slate-900/30"
                title="Add Load"
              >
                <Plus className="w-4 h-4" />
                <Truck className="w-4 h-4 ml-1" />
              </Button>
            </div>
          )}
        </div>
        <p className="text-slate-400 text-xs font-medium mt-0.5">{totalLoads} {totalLoads === 1 ? 'load' : 'loads'}</p>
      </div>
      {isApprover && (
        <div className="hidden sm:flex flex-wrap gap-2">
          {draftsCount > 0 && (
            <Button 
              variant="outline"
              size="sm"
              onClick={onToggleDrafts} 
              className="rounded-xl border-slate-400 text-slate-700 hover:bg-slate-100 text-sm"
            >
              <FileText className="w-4 h-4 mr-1" />
              Drafts ({draftsCount})
            </Button>
          )}
          <Button
            data-testid="filter-button-desktop"
            variant="outline"
            size="sm"
            onClick={onOpenFilter}
            className={`rounded-xl h-9 w-9 p-0 ${hasActiveFilters ? 'border-blue-500 text-blue-600 bg-blue-50' : ''}`}
            title="Filter"
          >
            <Filter className="w-4 h-4" />
          </Button>
          {hasActiveFilters && (
            <Button
              data-testid="clear-filter-button-desktop"
              variant="outline"
              size="sm"
              onClick={onClearFilter}
              className="rounded-xl h-9 w-9 p-0 border-red-300 text-red-600 hover:bg-red-50"
              title="Clear Filters"
            >
              <FilterX className="w-4 h-4" />
            </Button>
          )}
          {onOpenAdhocManager && (
            <Button
              data-testid="adhoc-manager-btn"
              variant="outline"
              size="sm"
              onClick={onOpenAdhocManager}
              className="rounded-xl h-9 px-3 text-slate-700 hover:bg-slate-100 text-sm"
              title="Manage adhoc loads — update weight (Balaji) / record adjustments + summary invoice (SVE)"
            >
              <Settings className="w-4 h-4 mr-1" />
              Adhoc
            </Button>
          )}
          <Button 
            data-testid="add-load-btn" 
            size="sm" 
            onClick={onOpenAdd} 
            className="h-9 px-3 bg-gradient-to-r from-slate-800 to-slate-900 hover:from-slate-700 hover:to-slate-800 text-white rounded-xl shadow-lg shadow-slate-900/30"
            title="Add Load"
          >
            <Plus className="w-4 h-4" />
            <Truck className="w-4 h-4 ml-1" />
          </Button>
        </div>
      )}
    </div>
  );
};
